import script from "./AdminMailTemplates.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminMailTemplates.vue?vue&type=script&setup=true&lang=js"

import "@/assets/styles/sfc/components/sites/AdminMailTemplates.css?vue&type=style&index=0&id=6a4501fb&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a4501fb"]])

export default __exports__